import React, { useEffect } from 'react';
import './index.scss';
export enum RESOLUTION {
  STANDARD = 'STANDARD',
  HIGH = 'HIGH',
  SMOOTH = 'SMOOTH',
  ULTRAFAST = 'ULTRAFAST',
  AUTO = 'AUTO',
}
const btnListMap = new Map([
  [RESOLUTION.HIGH, '高清'],
  [RESOLUTION.STANDARD, '标准'],
  [RESOLUTION.SMOOTH, '流畅'],
  [RESOLUTION.ULTRAFAST, '极速'],
  [RESOLUTION.AUTO, '自动'],
]);

const Resolution = (props: {
  videoMode: RESOLUTION;
  onChange?: (value: RESOLUTION, mesFlag?: boolean) => void;
  takeOverBySelf: boolean;
  signalQuality: 'EXCELLENT' | 'GOOD' | 'FAIR' | 'POOR';
  videoAutoMode: boolean;
}) => {
  const [selectResolution, setSelectResolution] = React.useState(
    RESOLUTION.STANDARD
  );
  const [showBtnList, setShowBtnList] = React.useState(false);

  useEffect(() => {
    setShowBtnList(false);
    setSelectResolution(
      props.videoAutoMode ? RESOLUTION.AUTO : props.videoMode
    );
  }, [props.videoMode, props.videoAutoMode]);

  const renderBtnList = () => {
    return Array.from(btnListMap.keys()).map((item) => (
      <i
        className={`resolution-btn-item ${
          item === selectResolution ? 'active' : ''
        }`}
        onClick={() => {
          setSelectResolution(item);
          props.onChange && props.onChange(item);
          setShowBtnList(!showBtnList);
        }}
      >
        {btnListMap.get(item)}
      </i>
    ));
  };

  return (
    <span className="resolution-list">
      <span
        className="selected-resolution"
        onClick={() => {
          if (!props.takeOverBySelf) {
            return;
          }
          setShowBtnList(!showBtnList);
        }}
      >
        {selectResolution === RESOLUTION.AUTO
          ? `自动(${btnListMap.get(props.videoMode)})`
          : btnListMap.get(selectResolution)}
      </span>
      {showBtnList && (
        <span className="resolution-btn-list">{renderBtnList()}</span>
      )}
    </span>
  );
};

export default React.memo(Resolution);
